<template>
  <div class="inner-graph-content">
    <Spinner :isLoading="isLoading" />
    <div class="vaccination-status">
      <div class="content-area">
        <h3 :class="vaccinations.length != 0 ? 'float-left' : ''">{{ $t('vaccination') }}</h3>
        <div v-if="vaccinations.length != 0" class="export-vaccin-btn" @click="onClickExportVaccinPDF">
          {{ $t('pdf_export') }}
        </div>
        <div class="table-content-area">
          <table>
              <tr>
                <th>{{ $t('vaccine_name') }}</th>
                <th v-for="shot in maxGettingVacxin" :key="shot">{{ $tc('number_of_shot_vaccin', shot) }}</th>
              </tr>
              <tr v-for="(item, index) in vaccinations" :key="index">
                <td>{{ item.name }}</td>
                <td :class="value.answer_value == 'no-vacxin-date' ? 'background' : null " v-for="(value, key) in item.date" :key="key">
                  {{ value.answer_value ? (value.answer_value == 'no-vacxin-date' ? '' : convertToJPTime(value.answer_value)) : '－' }}
                </td>
              </tr>
              <tr v-if="vaccinations.length == 0">
                <td colspan="5" style="text-align: center; font-size: 12px;">{{ $t('there_is_no_data') }}</td>
              </tr>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import { mapState } from "vuex"
import Spinner from "@/js/components/Spinner"
import { getInfoAndBasicInfo, convertToJPTime, params } from '@/js/commons/commons'

export default {
  components: {
    Spinner
  },
  props: {
    activePage: {
      type: String,
      required: true
    },
    isExportVaccinPDF: {
      type: Boolean,
      required: true
    },
    isLoadedBasicInfo: {
      type: Boolean,
      required: true
    },
  },
  data() {
    return {
      isLoading: true,
      maxGettingVacxin: 4,
    }
  },
  components: {
    Spinner
  },
  computed: {
    ...mapState({
      viewedHistories: state => state.patient.viewedHistories,
      info: state => state.patient.info,
      vaccination: state => state.homeCareBook.vaccinations,
      errorMsg: state => state.patient.errorMsg
    }),
    vaccinations() {
      const data = []
      const list = _(this.vaccination).groupBy('children_questionnaire_group_item_answer_id').map(function(items) { return items }).value()
      let maxShotTaken = list.length > 0 ? Math.max(...list.map(o => JSON.parse(o[1].answer).length)) : 0
      this.maxGettingVacxin = maxShotTaken > 4 ? maxShotTaken : 4
      list.forEach(element => {
        if (element.length > 0) {
          data.push({
            name: JSON.parse(element[0].answer).map(function(value) { return value.answer_value }).toString(),
            date: JSON.parse(element[1].answer).length < this.maxGettingVacxin ? this.addItems(JSON.parse(element[1].answer), JSON.parse(element[1].answer).length) : JSON.parse(element[1].answer)
          })
        }
      })
      return data
    },
  },
  watch: {
    async activePage() {
      if (this.activePage === 'vaccination') {
        await this.getData()
        this.isLoading = false
      }
    },
    async isExportVaccinPDF() {
      if(this.isExportVaccinPDF) {
        if(!this.isLoadedBasicInfo) {
          this.isLoading = true
          await getInfoAndBasicInfo(this.info.id)
          this.isLoading = false
          this.$emit('setLoadedBasicInfo', true)
        }
        this.$bvModal.hide('modal-pdf')
        this.$emit('setExportVaccinPDF', false)
        this.$store.dispatch('homeCareBook/setVaccinPDF', {
          maxGettingVaccin: this.maxGettingVacxin,
          vaccinData: this.vaccinations,
          child_name: this.$store.state.auth.typeOfUser !== 'pharmacy' ? this.info.name : this.viewedHistories.find((o) => { return o["child_id"] === this.$route.params.childId }).name
        })
        let routeData = this.$router.resolve({name: 'VaccinPDF'})
        window.open(routeData.href, '_blank')
      }
    }
  },
  methods: {
    onClickExportVaccinPDF() {
      this.$bvModal.show('modal-pdf')
    },
    async getData() {
      await this.$store.dispatch("homeCareBook/getBasicInfo", { params: params('basic_info', 'vaccination', 'get_latest', this.info.id) })
    },
    convertToJPTime(time) {
      return convertToJPTime(time)
    },
    addItems(items, count) {
      for (let index = count; index < this.maxGettingVacxin; index++) {
        items.push({
          answer_value: 'no-vacxin-date', 
          questionnaire_item_detail_id: null
        })
      }
      return items
    }
  },
}
</script>

<style lang="css">
  .background {
    background-color:#E4E4E4;
  }
  .export-vaccin-btn {
    padding: 0 20px;
    background-color: #FF8EA1;
    color: white;
    line-height: 30px;
    border-radius: 15px;
    text-align: center;
    float: right;
    position: relative;
    top: -5px;
  }
  .export-vaccin-btn:hover {
    cursor: pointer;
  }
</style>